module.exports = __webpack_public_path__ + "img/how3.5f9cc1c0.png";